import { AxiosError } from "axios";

import { ErrorCode, ErrorState } from "./ErrorState";

interface InlineErrorStateProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: AxiosError<GlobalErrorResponse, any> | null;
  onRetry?: () => void;
}

export const InlineErrorState: React.FC<InlineErrorStateProps> = ({
  error,
  onRetry,
}) => {
  if (!error?.response) {
    // Network error or unknown error - show 500
    return (
      <ErrorState
        errorCode={500}
        description={
          error?.message ||
          "Request failed with status code 500. The server encountered an error."
        }
        errorDetails="Internal server error. Our team has been notified."
        onTryAgain={onRetry}
        showActions={true}
        inline={true}
      />
    );
  }

  const status = error.response.status;
  let errorCode: ErrorCode = 500;

  if (status === 404) {
    errorCode = 404;
  } else if (status === 401) {
    errorCode = 401;
  } else if (status === 403) {
    errorCode = 403;
  } else if (status >= 500 && status < 600) {
    errorCode = 500;
  }

  return (
    <ErrorState
      errorCode={errorCode}
      description={
        error?.message ||
        (status >= 500
          ? "Request failed with status code 500. The server encountered an error."
          : status === 404
          ? "The page or resource you're looking for doesn't exist."
          : status === 401
          ? "Please log in to continue."
          : "You don't have permission to access this resource.")
      }
      errorDetails={
        status >= 500
          ? "Internal server error. Our team has been notified."
          : status === 404
          ? "The requested resource could not be found."
          : status === 401
          ? "You need to be authenticated to access this resource."
          : status === 403
          ? "You don't have permission to access this resource."
          : error?.response?.data?.error?.body ||
            error?.response?.data?.error?.title ||
            "An error occurred. Please try again."
      }
      onTryAgain={onRetry}
      showActions={true}
      inline={true}
    />
  );
};
